export default __webpack_public_path__ + "static/media/litho-demo-single-project-page-02.93c7334b.jpg";